const swal = require('sweetalert2');
const btnSuccessColor = '#41c43a';
const btnErrorColor = '#ed6060';

/**
 * @param message
 * @param reloadPage For now undefined and truthy values cause page reload
 */
function showError(message, reloadPage) {
    reloadPage = !!reloadPage || reloadPage === undefined;
    swal({
        title: 'Error',
        text: parseErrorMessage(message),
        type: 'error',
        customClass: 'sweet-alert-error',
        confirmButtonColor: btnErrorColor,
        allowEscapeKey: !reloadPage,
        confirmButtonText: reloadPage ? 'Reload page' : 'OK',
        reverseButtons: true
    }).then(function() {
        if (reloadPage) {
            window.location.reload();
        }
    });
}

function noop() {}

function info(options) {
    var $swal = $('.sweet-alert');
    $swal.removeClass($swal.data('customClass'));

    options = _.defaults(options || {}, {
        title:              '',
        text:               '',
        type:               'info',
        customClass:        'sweet-alert-success',
        confirmButtonColor: btnSuccessColor,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons: true
    });

    if (!_.isString(options.text)) {
        options.text = JSON.stringify(options.text);
    }

    /* swal1 compatibility */
    if (options.html === true) {
        options.html = options.text;
    }

    const callback = options.callback || noop;
    swal(options).then(() => {
        callback(true);
    }, () => {
        callback(false);
    });
}

function success(options) {
    var $swal = $('.sweet-alert');
    $swal.removeClass($swal.data('customClass'));

    options = _.defaults(options || {}, {
        title:              'Success!',
        text:               '',
        type:               'success',
        customClass:        'sweet-alert-success',
        confirmButtonColor: btnSuccessColor,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons:     true
    });

    if (!_.isString(options.text)) {
        options.text = JSON.stringify(options.text);
    }

    /* swal1 compatibility */
    if (options.html === true) {
        options.html = options.text;
    }

    const callback = options.callback || noop;
    swal(options).then(() => {
        callback(true);
    }, () => {
        callback(false);
    });
}

function warning(options) {
    var $swal = $('.sweet-alert');
    $swal.removeClass($swal.data('customClass'));

    options = _.defaults(options || {}, {
        title:              'Warning',
        text:               '',
        type:               'warning',
        confirmButtonColor: btnSuccessColor,
        allowEscapeKey:     true,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons:     true
    });

    if (!_.isString(options.text)) {
        options.text = JSON.stringify(options.text);
    }

    /* swal1 compatibility */
    if (options.html === true) {
        options.html = options.text;
    }

    const callback = options.callback || noop;
    swal(options).then((result) => {
        if (options.input) {
            callback(result);
        } else {
            callback(true);
        }
    }, () => {
        callback(false);
    });
}

function parseErrorMessage(err) {
    if (typeof err === 'string') {
        return err;
    }
    if (err.message && typeof err.message === 'object' && err.message.message) {
        return err.message.message;
    }

    if (err.response && err.response.error) {
        return err.response.error.message || JSON.stringify(err.response.error);
    }

    if (typeof err.message === 'string') {
        return err.message;
    }
    return 'An unknown error occurred';
}

function error(options, confirmatioBtn = true) {
    var $swal = $('.sweet-alert');
    $swal.removeClass($swal.data('customClass'));

    options = _.defaults(options || {}, {
        title:              'Error',
        text:               'An unknown error occurred',
        type:               'error',
        customClass:        'sweet-alert-error',
        showConfirmButton:  confirmatioBtn,
        confirmButtonColor: btnErrorColor,
        allowEscapeKey:     false,
        confirmButtonText:  'Reload',
        callback:           window.location.reload.bind(window.location),
        reverseButtons:     true
    });

    if (typeof options.text === 'object') {
        options.text = parseErrorMessage(options.text);
    }

    /* swal1 compatibility */
    if (options.html === true) {
        options.html = options.text;
    }

    const callback = options.callback || noop;
    swal(options).then(() => {
        callback(true);
    }, () => {
        callback(false);
    });
}

function confirm(options) {
    var $swal = $('.sweet-alert');
    $swal.removeClass($swal.data('customClass'));

    options = _.defaults(options || {}, {
        title:              'Are you sure?',
        text:               'Yes, I\'m sure',
        type:               'warning',
        confirmButtonColor: btnSuccessColor,
        showCancelButton:   true,
        allowEscapeKey:     false,
        confirmButtonText:  'Cancel',
        callback:           noop,
        reverseButtons:     true
    });

    if (!_.isString(options.text)) {
        options.text = JSON.stringify(options.text);
    }

    /* swal1 compatibility */
    if (options.html === true) {
        options.html = options.text;
    }

    const callback = options.callback || noop;
    swal(options).then(() => {
        callback(true);
    }, () => {
        callback(false);
    });
}

function closeAll() {
    return swal.close();
}

/**
 * @param text {String}
 */
function showAlertSuccess(text) {
    var $el = $(
        '<div class="global-alert-box">' +
            '<div class="alert alert-success global-alert">' + text + '</div>' +
        '</div>'
    ).hide();
    $('body').prepend($el);

    $el.fadeIn(200)
        .delay(2000)
        .fadeOut(300, function() {
            $(this).remove();
        });
}

module.exports = {
    info:             info,
    success:          success,
    error:            error,
    warning:          warning,
    confirm:          confirm,
    closeAll:         closeAll,
    showError:        showError,
    showAlertSuccess: showAlertSuccess
};



// WEBPACK FOOTER //
// ./app/helpers/modal.js